import {
  useCreateDataFileMutation,
  useGetCurrentUserQuery,
  useLazyGetDataFilesQuery,
  useLazyGetSubjectsQuery,
  useLazyGetUsersQuery,
} from "@/redux/service";
import { useTranslation } from "react-i18next";

import { DataTemplate } from "@/core/datablocks/types/templates";

export const useDataBlockDependencies = (
  dataTemplate: DataTemplate | undefined,
) => {
  const { t } = useTranslation();
  const { data: currentUser } = useGetCurrentUserQuery();
  const [getUsers] = useLazyGetUsersQuery();
  const [getSubjects] = useLazyGetSubjectsQuery();
  const [getDataFiles] = useLazyGetDataFilesQuery();
  const [createDataFile] = useCreateDataFileMutation();

  if (!dataTemplate || !currentUser) return;

  return {
    getUsers,
    getSubjects,
    getDataFiles,
    createDataFile,
    t,
    currentUser,
    dataTemplate,
  };
};
